<template>
  <v-modal
    size="sm"
    :closable="false"
  >
    <template v-slot:title>
      <h4 class="m-0">
        {{ $t('phrase.almost_finished') }}
      </h4>
    </template>

    <template v-slot:body>
      <div>
        <p class="text-muted">
          {{ $t('sentence.fill_in_and_get_reward') }}
        </p>

        <div class="mb-3">
          <v-text-input
            label="word.zip"
            help-text="phrase.zip_four_digits"
            v-model="formData.zip"
            :errors="errors.zip"
            :max-length="4"
          />
        </div>

        <div class="mb-3">
          <v-radio-buttons
            label="word.gender"
            :choices="GENDER_CHOICES"
            v-model="formData.gender"
            :errors="errors.gender"
            :horizontal="true"
          />
        </div>

        <div>
          <v-date-input
            label="word.birth_date"
            :errors="errors.birth_date"
            v-model="formData.birth_date"
            :max-date="new Date()"
            :min-date="new Date(1900, 1, 1)"
            :required="true"
          />
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div>
        <v-button
          :block="true"
          text="word.save"
          @click="updateProfile()"
          style-type="secondary"
          :loader="loader"
          v-if="redirectUrl"
        />
      </div>
    </template>
  </v-modal>
</template>

<script>
import Button from '@/common/components/Button.vue';
import Modal from '@/common/components/Modal.vue';
import RadioButtons from '@/common/components/inputs/RadioButtons.vue';
import TextInput from '@/common/components/inputs/TextInput.vue';
import api from '@/common/api';
import { mapGetters } from 'vuex';
import { toFormattedDate } from '@/common/utils/formatting';
import DateInput from '@/common/components/inputs/DateInput.vue';
import { fetchExternalParty } from '@/reviewer/api';
import { objectToQueryParams } from '@/common/utils/urls';
import { GENDER_CHOICES } from '@/common/utils/constants';


export default {
  name: 'ExternalRedirectModal',
  components: {
    'v-button': Button,
    'v-date-input': DateInput,
    'v-modal': Modal,
    'v-radio-buttons': RadioButtons,
    'v-text-input': TextInput,
  },
  props: {
    externalPartySlug: {
      type: String,
      required: true,
    },
    researchSetIdentifier: {
      type: String,
      required: true,
    },
    userIdentifier: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      GENDER_CHOICES,
      step: 1,
      redirectUrl: null,
      formData: {
        zip: null,
        gender: null,
        birth_date: null,
      },
      loader: { loading: false },
      errors: {},
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  created() {
    this.fetchExternalParty();
    // TODO: if all information is in the profile already, skip this step;
    // this.formData.zip = this.user.profile.zip;
    // this.formData.gender = this.user.profile.gender;
    // if (this.user.profile.birth_date) {
    //   this.formData.birth_date = new Date(this.user.profile.birth_date);
    // }
  },
  methods: {
    async fetchExternalParty() {
      const response = await fetchExternalParty(
        this.externalPartySlug,
        this.researchSetIdentifier,
        this.userIdentifier,
      );
      this.redirectUrl = response.data.redirect_url;
      if (Object.keys(this.$route.query).includes('pid') && Object.keys(this.$route.query).includes('cid')) {
        // Temporary fix for the redirect url until there is no
        // combination between researches and commercials anymore;
        this.redirectUrl = `https://www.panelclix.com/nl/research/evaluation.html?cid=${this.$route.query.cid}&pid=${this.$route.query.pid}`;
      } else {
        // Adds extra query params to the redirect url;
        const {
          ep, rsid, uid, ...extraQuery
        } = this.$route.query;
        if (Object.keys(extraQuery).length > 0) {
          this.redirectUrl += `&${objectToQueryParams(extraQuery)}`;
        }
      }
    },
    async updateProfile() {
      this.loader.loading = true;
      const formData = {
        ...this.formData,
        ...{ birth_date: toFormattedDate(this.formData.birth_date) },
      };

      const response = await api.patch(
        `user-profiles/${this.user.profile.id}/`,
        formData,
      );
      if (response.status === 400) {
        this.errors = response.data;
        this.loader.loading = false;
        return;
      }

      this.$emit('rewards-claimed', this.redirectUrl, formData);
    },
  },
};
</script>
